import * as React from 'react'
import { cn } from '../../lib/utils'

export interface FormTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean
}

export const FormTextarea = React.forwardRef<
  HTMLTextAreaElement,
  FormTextareaProps
>(({ className, error, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'placeholder:text-muted-foreground flex min-h-[100px] w-full resize-y rounded-md border border-gray-300 bg-background px-3 py-2 text-sm ring-offset-background focus-visible:border-admin-blue focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-admin-blue disabled:cursor-not-allowed disabled:opacity-50',
        error &&
          'border-red-500 focus-visible:border-red-500 focus-visible:ring-red-500',
        className
      )}
      ref={ref}
      {...props}
    />
  )
})

FormTextarea.displayName = 'FormTextarea'
